import { loadAutomates } from "./storage.js";
import { Automate, RootFilterBlock } from "./types.js";

export function getAutomates(): Automate[] {
    return loadAutomates();
}

export function automatesByRootType(logType: string): Automate[] {
    return getAutomates().filter((auto) => {
        const block = auto.blocks[0] as RootFilterBlock | undefined;
        return block?.config?.logType === logType;
    });
}

export function buildAutomateMenuItems(
    logType: string,
    onSelect: (auto: Automate) => void,
    onCreate: () => void,
) {
    const matches = automatesByRootType(logType);

    if (!matches.length) {
        return [{
            icon    : () => <i class="material-symbols-outlined">add_circle</i>,
            label   : () => "Créer un automate",
            onClick : onCreate,
        }];
    }

    return [
        {
            icon    : () => <i class="material-symbols-outlined">play_arrow</i>,
            label   : () => "Exécuter l'automate",
            children: [
                ...matches.map((auto) => ({
                    icon    : () => <i class="material-symbols-outlined">play_circle</i>,
                    label   : () => auto.name,
                    onClick : () => onSelect(auto),
                })),
                {
                    icon    : () => <i class="material-symbols-outlined">add_circle</i>,
                    label   : () => "Créer un automate",
                    onClick : onCreate,
                },
            ],
        },
    ];
}
